/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleDate/theme';

export const ArticleDateTheme = theme;
